import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';

type InputProps = {
  employee: Employee;
  children: React.ReactElement;
  integrationName?: string | null;
};

export const EmployeeListIntegrationDisabler = ({
  employee,
  children,
  integrationName,
}: InputProps) => {
  if (!employee.integrationId) {
    return children;
  }

  const disabledChildren = React.cloneElement(children, { disabled: true });

  return (
    <Tooltip
      title={`Please perform this action in ${integrationName || 'your HR/payroll system'}`}
      placement="top"
    >
      <span>{disabledChildren}</span>
    </Tooltip>
  );
};
